import React, { useEffect, useState } from 'react';
import close_button from '../../../assets/close_button.png';
import ScmModuleStyle from '../styles/scm.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);
require('highcharts/modules/heatmap')(Highcharts);

const UnitsBySuppliersGraph = ({ type, simObj, setSimObj }) => {
  const [gGraphStyle, setGGraphStyle] = useState({ left: 0, top: 0 });
  const [monthlydata, setMonthlyData] = useState('');
  const [RevenueData, setRevenueData] = useState({ "first": [], "second": [], "third": [], "fourth": [] });
  const [CostsData, setCostsData] = useState({ "first": [], "second": [], "third": [], "fourth": [] });
  const [quarterMax,setQuarterMax]=useState([])
  const [xAxisMinMax, setXAxisMinMax] = useState({ "first": { min: 1, max: quarterMax[0] }, "second": { min: 1, max: quarterMax[1] }, "third": { min: 1, max: quarterMax[2] }, "fourth": { min: 1, max: quarterMax[3] } });
  const [isShowD, setIsShowD] = useState(true);
  const [revenueGraphLabel, setUnitsBySuppliersGraphLabel] = useState("");
  const [chart, setChart] = useState(null);



  let graphSettings = {}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  const countSaturdaysInQuarter = (quarter) => {
    // Define quarter start and end dates
    const year = simObj?.laststate?.stateyear//new Date().getFullYear(); 
    const quarters = {
      1: [new Date(year, 0, 1), new Date(year, 2, 31)],
      2: [new Date(year, 3, 1), new Date(year, 5, 30)],
      3: [new Date(year, 6, 1), new Date(year, 8, 30)],
      4: [new Date(year, 9, 1), new Date(year, 11, 31)]
    };

    const [startDate, endDate] = quarters[quarter];

    // Count Saturdays within the specified quarter
    let saturdayCount = 0;
    for (let currentDate = new Date(startDate); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
      if (currentDate.getDay() === 6) { // Saturday has index 6
        saturdayCount++;
      }
    }

    return saturdayCount;
  }
  const setGraphData = () => {
    if (chart != undefined) {
      let firstQuarterSKU1Supplires = [];
      let firstQuarterReq2PerWeek = [];
      let secondQuarterReq1PerWeek = [];
      let secondQuarterReq2PerWeek = [];
      let thirdQuarterReq1PerWeek = [];
      let thirdQuarterReq2PerWeek = [];
      let fourthQuarterReq1PerWeek = [];
      let fourthQuarterReq2PerWeek = [];
      let firstQuarterSKU2Supplires = [];
      let secondQuarterSKU1Supplires = [];
      let secondQuarterSKU2Supplires = [];
      let thirdQuarterSKU1Supplires = [];
      let thirdQuarterSKU2Supplires = [];
      let fourthQuarterSKU1Supplires = [];
      let fourthQuarterSKU2Supplires = [];


      let monthDays = 0;
      let newPoint = "";
      let existingData = "";
      let newData = "";
      let date = new Date();

      chart?.yAxis != undefined && chart?.yAxis[0]?.setCategories([...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
        return simObj?.supplierDetails[supplier].supplierComp1Available == 1
      }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
        return simObj?.supplierDetails[supplier].supplierComp2Available == 1
      })].map(supplierKey => simObj?.supplierDetails[supplierKey].supplierName));
      const SKU1dashedLinedefault = ([...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
        return simObj?.supplierDetails[supplier].supplierComp1Available == 1
      })].length - 1);
      chart?.yAxis != undefined && chart.yAxis[0].update({
        plotLines: [{
          color: 'rgb(112,112,112,1.5)',
          width: 1,
          value: SKU1dashedLinedefault + (0.5),
          dashStyle: 'Dash',
          zIndex: 5, // To ensure the line is above the heatmap

        }]
      });

      switch (type) {
        case "first":
          // let supplierbyId= simObj?.supplierDetails != null && Object.entries(simObj?.supplierDetails)?.map(([supplier_id, supplier]) => (supplier?.supplierComp1Available))
          // console.log(supplierbyId)
          firstQuarterSKU1Supplires = simObj?.graphdata;
          firstQuarterSKU1Supplires = firstQuarterSKU1Supplires?.filter(obj => { return obj?.qt === 1 });
          firstQuarterSKU1Supplires = (firstQuarterSKU1Supplires != undefined ? firstQuarterSKU1Supplires : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c1pw),
              requiredComponent1PerWeek: data.c1pw,
              supplierOrderDetailsComp1: data.so.Component1,
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            first: firstQuarterSKU1Supplires
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            first: { min: 1, max: xAxisMinMax.first.max }
          }));

          let firstQuarterSKU1 = firstQuarterSKU1Supplires.map((item) => item.supplierOrderDetailsComp1)
          //let valuesToCompare = ["receivedOrdersUnits", "remainingUnits", "weeklySupplyPerUnit"];  
          let supplierKeys1 = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp1Available == 1
          }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp2Available == 1
          })]
          let pRslt1 = [];
          firstQuarterSKU1.forEach((pArrItem, index) => {
            if (Array.isArray(pArrItem)) {
              let cRslt = [];
              let dataLabelColor = '#005A70';
              let dataLabelStroke = '#005A70';
              let dataLabelFillColor = 'white';
              pArrItem.forEach((cArrItem) => {
                if (cArrItem.pendingUnits !== undefined) {
                  cArrItem.dataLabels = { color: dataLabelColor, borderColor: dataLabelStroke, fillColor: dataLabelFillColor };
                  // pendingUnits
                  cRslt.push({ "supplier": cArrItem.supplierId, "value":  Number(cArrItem.pendingUnits), "label": cArrItem.dataLabels });
                } else {
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": (cArrItem.scmIssuesTypes && cArrItem.scmIssuesTypes.indexOf("_") !== -1) ? "E" : Number(cArrItem.receivedOrdersUnits) });
                }
              })
              for (var i = 0; i < cRslt.length; i++) {
                let supplier = cRslt[i].supplier;
                let lastIndexOfSupplier = cRslt.map(item => item.supplier).lastIndexOf(supplier); 
                let yAxisIndex = lastIndexOfSupplier !== -1 ? supplierKeys1.indexOf(supplier) : null;
                let value = lastIndexOfSupplier !== -1 ? cRslt[lastIndexOfSupplier].value : null;
                let color = value === "E" ? 'black' : cRslt[i].label ? 'white' : 'rgb(0, 90, 112)';                
                pRslt1.push({ x: index + 1, y: yAxisIndex, value, color, dataLabels: cRslt[i].label, borderColor: '#005A70' });
              }
            } else {
              pRslt1.push({ x: index + 1, y: 0, value: Number(pArrItem), color: null })
            }
          })
          if (pRslt1.filter((obj) => obj.y == 7).length == 0) {
            pRslt1.push({ "x": xAxisMinMax.first.max, "y": 7, "value": 0, "color": null });
          }
          if (pRslt1.filter((obj) => obj.y == 0).length == 0) {
            pRslt1.push({ "x": 0, "y": 0, "value": 0, "color": null });
          }

          // if (chart !== undefined && chart?.series !== undefined && chart?.series[0] !== undefined) {
          //   chart?.series[0]?.setData(pRslt1);
          // }
          //console.log("pRslt1", pRslt1.filter((obj) => obj.y != null))
          //firstQuarterSKU2Supplires
          firstQuarterSKU2Supplires = simObj?.graphdata;
          firstQuarterSKU2Supplires = firstQuarterSKU2Supplires?.filter(obj => { return obj?.qt === 1 });
          firstQuarterSKU2Supplires = (firstQuarterSKU2Supplires != undefined ? firstQuarterSKU2Supplires : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c2pw),
              requiredComponent2PerWeek: data.c2pw,
              supplierOrderDetailsComp2: data.so.Component2,
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            first: firstQuarterSKU2Supplires
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            first: { min: 1, max: xAxisMinMax.first.max }
          }));
          let firstQuarterSKU2 = firstQuarterSKU2Supplires.map((item) => item.supplierOrderDetailsComp2)
          //let valuesToCompare = ["receivedOrdersUnits", "remainingUnits", "weeklySupplyPerUnit"];  
          let supplierKeys2 = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp1Available == 1
          }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp2Available == 1
          })]

          let pRslt2 = [];
          firstQuarterSKU2.forEach((pArrItem, index) => {
            if (Array.isArray(pArrItem)) {
              let cRslt = [];
              let dataLabelColor = '#D46719';
              let dataLabelStroke = '#D46719';
              let dataLabelFillColor = 'white';
              pArrItem.forEach((cArrItem) => {
                if (cArrItem.pendingUnits !== undefined) {
                  cArrItem.dataLabels = { color: dataLabelColor, borderColor: dataLabelStroke, fillColor: dataLabelFillColor };
                  // pendingUnits
                  cRslt.push({ "supplier": cArrItem.supplierId, "value":  Number(cArrItem.pendingUnits), "label": cArrItem.dataLabels });
                } else {
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": (cArrItem.scmIssuesTypes && cArrItem.scmIssuesTypes.indexOf("_") !== -1) ? "E" : Number(cArrItem.receivedOrdersUnits) });
                }
              })
              for (var i = 0; i < cRslt.length; i++) {
                let supplier = cRslt[i].supplier;
                let lastIndexOfSupplier = cRslt.map(item => item.supplier).lastIndexOf(supplier); 
                let yAxisIndex = lastIndexOfSupplier !== -1 ? supplierKeys2.indexOf(supplier) : null;
                let value = lastIndexOfSupplier !== -1 ? cRslt[lastIndexOfSupplier].value : null;
                let color = value === "E" ? 'black' : cRslt[i].label ? 'white' : 'rgb(212, 103, 25)';
                pRslt2.push({ x: index + 1, y: yAxisIndex, value, color, dataLabels: cRslt[i].label, borderColor: '#D46719' });
              }
            } else {
              pRslt2.push({ x: index + 1, y: 0, value: Number(pArrItem), color: null })
            }
          })
          if (pRslt2.filter((obj) => obj.y == 7).length == 0) {
            pRslt2.push({ "x": xAxisMinMax.first.max, "y": 7, "value": 0, "color": null });
          }
          if (pRslt2.filter((obj) => obj.y == 0).length == 0) {
            pRslt2.push({ "x": 0, "y": 0, "value": 0, "color": null });
          }

          if (chart !== undefined && chart?.series !== undefined && chart?.series[0] !== undefined) {
            chart?.series[0]?.setData([...pRslt1.filter((obj) => obj.y != null), ...pRslt2.filter((obj) => obj.y != null)]);
          }

          break;

        case "second":
          //secondQuarterReq1PerWeek
          secondQuarterSKU1Supplires = simObj?.graphdata
          secondQuarterSKU1Supplires = secondQuarterSKU1Supplires?.filter(obj => obj?.qt === 2);
          secondQuarterSKU1Supplires = (secondQuarterSKU1Supplires != undefined ? secondQuarterSKU1Supplires : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c1pw),
              requiredComponent1PerWeek: data.c1pw,
              supplierOrderDetailsComp1: data.so.Component1,
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            second: secondQuarterSKU1Supplires
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            second: { min: 1, max: xAxisMinMax.second.max }
          }));
          //console.log(secondQuarterSKU1Supplires)
          let secondQuarterSKU1 = secondQuarterSKU1Supplires.map((item) => item.supplierOrderDetailsComp1)
          //let valuesToCompare = ["receivedOrdersUnits", "remainingUnits", "weeklySupplyPerUnit"];  
          let supplierKeysSec1 = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp1Available == 1
          }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp2Available == 1
          })]

          let pRsltsec1 = [];
          secondQuarterSKU1.forEach((pArrItem, index) => {
            if (Array.isArray(pArrItem)) {
              let cRslt = [];
              let dataLabelColor = '#005A70';
              let dataLabelStroke = '#005A70';
              let dataLabelFillColor = 'white';
              pArrItem.forEach((cArrItem) => {
                if (cArrItem.pendingUnits !== undefined) {
                  cArrItem.dataLabels = { color: dataLabelColor, borderColor: dataLabelStroke, fillColor: dataLabelFillColor };
                  // pendingUnits
                  cRslt.push({ "supplier": cArrItem.supplierId, "value":  Number(cArrItem.pendingUnits), "label": cArrItem.dataLabels });
                } else {
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": (cArrItem.scmIssuesTypes && cArrItem.scmIssuesTypes.indexOf("_") !== -1) ? "E" : Number(cArrItem.receivedOrdersUnits) });
                }
              })
              for (var i = 0; i < cRslt.length; i++) {
                let supplier = cRslt[i].supplier;
                let lastIndexOfSupplier = cRslt.map(item => item.supplier).lastIndexOf(supplier); 
                let yAxisIndex = lastIndexOfSupplier !== -1 ? supplierKeysSec1.indexOf(supplier) : null;
                let value = lastIndexOfSupplier !== -1 ? cRslt[lastIndexOfSupplier].value : null;
                let color = value === "E" ? 'black' : cRslt[i].label ? 'white' : 'rgb(0, 90, 112)';
                pRsltsec1.push({ x: index + 1, y: yAxisIndex, value, color, dataLabels: cRslt[i].label, borderColor: '#005A70' });
              }
            } else {
              pRsltsec1.push({ x: index + 1, y: 0, value: Number(pArrItem), color: null, dataLabels: null })
            }
          })
          if (pRsltsec1.filter((obj) => obj.y == 7).length == 0) {
            pRsltsec1.push({ "x": xAxisMinMax.second.max, "y": 7, "value": 0, "color": null });
          }
          if (pRsltsec1.filter((obj) => obj.y == 0).length == 0) {
            pRsltsec1.push({ "x": 0, "y": 0, "value": 0, "color": null });
          }

          //secondQuarterReq2PerWeek
          secondQuarterSKU2Supplires = simObj?.graphdata;
          secondQuarterSKU2Supplires = secondQuarterSKU2Supplires?.filter(obj => obj?.qt === 2);
          secondQuarterSKU2Supplires = (secondQuarterSKU2Supplires != undefined ? secondQuarterSKU2Supplires : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c2pw),
              requiredComponent2PerWeek: data.c2pw,
              supplierOrderDetailsComp2: data.so.Component2,
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            second: secondQuarterSKU2Supplires
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            second: { min: 1, max: xAxisMinMax.second.max }
          }));
          let secondQuarterSKU2 = secondQuarterSKU2Supplires.map((item) => item.supplierOrderDetailsComp2)
          //let valuesToCompare = ["receivedOrdersUnits", "remainingUnits", "weeklySupplyPerUnit"];  
          let supplierKeysSec2 = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp1Available == 1
          }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp2Available == 1
          })]

          let pRsltsec2 = [];
          secondQuarterSKU2.forEach((pArrItem, index) => {
            if (Array.isArray(pArrItem)) {
              let cRslt = [];
              let dataLabelColor = '#D46719';
              let dataLabelStroke = '#D46719';
              let dataLabelFillColor = 'white';
              pArrItem.forEach((cArrItem) => {
                if (cArrItem.pendingUnits !== undefined) {
                  cArrItem.dataLabels = { color: dataLabelColor, borderColor: dataLabelStroke, fillColor: dataLabelFillColor };
                  // pendingUnits
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": Number(cArrItem.pendingUnits), "label": cArrItem.dataLabels });
                } else {
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": (cArrItem.scmIssuesTypes && cArrItem.scmIssuesTypes.indexOf("_") !== -1) ? "E" : Number(cArrItem.receivedOrdersUnits) });
                }
              })
              for (var i = 0; i < cRslt.length; i++) {
                let supplier = cRslt[i].supplier;
                let lastIndexOfSupplier = cRslt.map(item => item.supplier).lastIndexOf(supplier); 
                let yAxisIndex = lastIndexOfSupplier !== -1 ? supplierKeysSec2.indexOf(supplier) : null;
                let value = lastIndexOfSupplier !== -1 ? cRslt[lastIndexOfSupplier].value : null;
                let color = value === "E" ? 'black' : cRslt[i].label ? 'white' : 'rgb(212, 103, 25)';
                pRsltsec2.push({ x: index + 1, y: yAxisIndex, value, color, dataLabels: cRslt[i].label, borderColor: '#D46719' });
              }
            } else {
              pRsltsec2.push({ x: index + 1, y: 0, value: Number(pArrItem), color: null })
            }
          })

          if (pRsltsec2.filter((obj) => obj.y == 7).length == 0) {
            pRsltsec2.push({ "x": xAxisMinMax.second.max, "y": 7, "value": 0, "color": null });
          }
          if (pRsltsec2.filter((obj) => obj.y == 0).length == 0) {
            pRsltsec2.push({ "x": 0, "y": 0, "value": 0, "color": null });
          }
          if (chart !== undefined && chart?.series !== undefined && chart?.series[0] !== undefined) {
            chart?.series[0]?.setData([...pRsltsec1.filter((obj) => obj.y != null), ...pRsltsec2.filter((obj) => obj.y != null)]);
          }

          break;

        case "third":
          //thirdQuarterReq1PerWeek
          thirdQuarterSKU1Supplires = simObj?.graphdata
          thirdQuarterSKU1Supplires = thirdQuarterSKU1Supplires?.filter(obj => obj?.qt === 3);
          thirdQuarterSKU1Supplires = (thirdQuarterSKU1Supplires != undefined ? thirdQuarterSKU1Supplires : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c1pw),
              requiredComponent1PerWeek: data.c1pw,
              supplierOrderDetailsComp1: data.so.Component1,
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            third: thirdQuarterSKU1Supplires
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            third: { min: 1, max: xAxisMinMax.third.max }
          }));
          let thirdQuarterSKU1 = thirdQuarterSKU1Supplires.map((item) => item.supplierOrderDetailsComp1)
          //let valuesToCompare = ["receivedOrdersUnits", "remainingUnits", "weeklySupplyPerUnit"];  
          let supplierKeysthird1 = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp1Available == 1
          }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp2Available == 1
          })]

          let pRsltthird1 = [];
          thirdQuarterSKU1.forEach((pArrItem, index) => {
            if (Array.isArray(pArrItem)) {
              let cRslt = [];
              let dataLabelColor = '#005A70';
              let dataLabelStroke = '#005A70';
              let dataLabelFillColor = 'white';
              pArrItem.forEach((cArrItem) => {
                if (cArrItem.pendingUnits !== undefined) {
                  cArrItem.dataLabels = { color: dataLabelColor, borderColor: dataLabelStroke, fillColor: dataLabelFillColor };
                  // pendingUnits
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": Number(cArrItem.pendingUnits), "label": cArrItem.dataLabels });
                } else {
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": (cArrItem.scmIssuesTypes && cArrItem.scmIssuesTypes.indexOf("_") !== -1) ? "E" : Number(cArrItem.receivedOrdersUnits) });
                }
              })
              for (var i = 0; i < cRslt.length; i++) {
                let supplier = cRslt[i].supplier;
                let lastIndexOfSupplier = cRslt.map(item => item.supplier).lastIndexOf(supplier); 
                let yAxisIndex = lastIndexOfSupplier !== -1 ? supplierKeysthird1.indexOf(supplier) : null;
                let value = lastIndexOfSupplier !== -1 ? cRslt[lastIndexOfSupplier].value : null;
                let color = value === "E" ? 'black' : cRslt[i].label ? 'white' : 'rgb(0, 90, 112)';
                pRsltthird1.push({ x: index + 1, y: yAxisIndex, value, color, dataLabels: cRslt[i].label, borderColor: '#005A70' });
              }
            } else {
              pRsltthird1.push({ x: index + 1, y: 0, value: Number(pArrItem), color: null })
            }
          })
          if (pRsltthird1.filter((obj) => obj.y == 7).length == 0) {
            pRsltthird1.push({ "x": xAxisMinMax.third.max, "y": 7, "value": 0, "color": null });
          }
          if (pRsltthird1.filter((obj) => obj.y == 0).length == 0) {
            pRsltthird1.push({ "x": 0, "y": 0, "value": 0, "color": null });
          }

          //thirdQuarterReq2PerWeek
          thirdQuarterSKU2Supplires = simObj?.graphdata;
          thirdQuarterSKU2Supplires = thirdQuarterSKU2Supplires?.filter(obj => obj?.qt === 3);
          thirdQuarterSKU2Supplires = (thirdQuarterSKU2Supplires != undefined ? thirdQuarterSKU2Supplires : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c2pw),
              requiredComponent2PerWeek: data.c2pw,
              supplierOrderDetailsComp2: data.so.Component2,
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            third: thirdQuarterSKU2Supplires
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            third: { min: 1, max: xAxisMinMax.third.max }
          }));

          let thirdQuarterSKU2 = thirdQuarterSKU2Supplires.map((item) => item.supplierOrderDetailsComp2)
          //let valuesToCompare = ["receivedOrdersUnits", "remainingUnits", "weeklySupplyPerUnit"];  
          let supplierKeysthird2 = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp1Available == 1
          }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp2Available == 1
          })]

          let pRsltthird2 = [];
          thirdQuarterSKU2.forEach((pArrItem, index) => {
            if (Array.isArray(pArrItem)) {
              let cRslt = [];
              let dataLabelColor = '#D46719';
              let dataLabelStroke = '#D46719';
              let dataLabelFillColor = 'white';
              pArrItem.forEach((cArrItem) => {
                if (cArrItem.pendingUnits !== undefined) {
                  cArrItem.dataLabels = { color: dataLabelColor, borderColor: dataLabelStroke, fillColor: dataLabelFillColor };
                  // pendingUnits
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": Number(cArrItem.pendingUnits), "label": cArrItem.dataLabels });
                } else {
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": (cArrItem.scmIssuesTypes && cArrItem.scmIssuesTypes.indexOf("_") !== -1) ? "E" : Number(cArrItem.receivedOrdersUnits) });
                }
              })
              for (var i = 0; i < cRslt.length; i++) {  
                let supplier = cRslt[i].supplier;
                let lastIndexOfSupplier = cRslt.map(item => item.supplier).lastIndexOf(supplier); 
                let yAxisIndex = lastIndexOfSupplier !== -1 ? supplierKeysthird2.indexOf(supplier) : null;
                let value = lastIndexOfSupplier !== -1 ? cRslt[lastIndexOfSupplier].value : null;
                let color = value === "E" ? 'black' : cRslt[i].label ? 'white' : 'rgb(212, 103, 25)';
                pRsltthird2.push({ x: index + 1, y: yAxisIndex, value, color, dataLabels: cRslt[i].label, borderColor: '#D46719' });
              }
            } else {
              pRsltthird2.push({ x: index + 1, y: 0, value: Number(pArrItem), color: null })
            }
          })

          if (pRsltthird2.filter((obj) => obj.y == 7).length == 0) {
            pRsltthird2.push({ "x": xAxisMinMax.third.max, "y": 7, "value": 0, "color": null });
          }
          if (pRsltthird2.filter((obj) => obj.y == 0).length == 0) {
            pRsltthird2.push({ "x": 0, "y": 0, "value": 0, "color": null });
          }
          if (chart !== undefined && chart?.series !== undefined && chart?.series[0] !== undefined) {
            chart?.series[0]?.setData([...pRsltthird1.filter((obj) => obj.y != null), ...pRsltthird2.filter((obj) => obj.y != null)]);
          }

          break;

        case "fourth":
          //fourthQuarterReq1PerWeek
          fourthQuarterSKU1Supplires = simObj?.graphdata
          fourthQuarterSKU1Supplires = fourthQuarterSKU1Supplires?.filter(obj => obj?.qt === 4);
          fourthQuarterSKU1Supplires = (fourthQuarterSKU1Supplires != undefined ? fourthQuarterSKU1Supplires : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c1pw),
              requiredComponent1PerWeek: data.c1pw,
              supplierOrderDetailsComp1: data.so.Component1,
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            fourth: fourthQuarterSKU1Supplires
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            fourth: { min: 1, max: xAxisMinMax.fourth.max }
          }));
          let fourthQuarterSKU1 = fourthQuarterSKU1Supplires.map((item) => item.supplierOrderDetailsComp1)
          //let valuesToCompare = ["receivedOrdersUnits", "remainingUnits", "weeklySupplyPerUnit"];  
          let supplierKeysfourth1 = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp1Available == 1
          }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp2Available == 1
          })]

          let pRsltfourth1 = [];
          fourthQuarterSKU1.forEach((pArrItem, index) => {
            if (Array.isArray(pArrItem)) {
              let cRslt = [];
              let dataLabelColor = '#005A70';
              let dataLabelStroke = '#005A70';
              let dataLabelFillColor = 'white';
              pArrItem.forEach((cArrItem) => {
                if (cArrItem.pendingUnits !== undefined) {
                  cArrItem.dataLabels = { color: dataLabelColor, borderColor: dataLabelStroke, fillColor: dataLabelFillColor };
                  // pendingUnits
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": Number(cArrItem.pendingUnits), "label": cArrItem.dataLabels });
                } else {
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": (cArrItem.scmIssuesTypes && cArrItem.scmIssuesTypes.indexOf("_") !== -1) ? "E" : Number(cArrItem.receivedOrdersUnits) });
                }
              })
              for (var i = 0; i < cRslt.length; i++) {
                let supplier = cRslt[i].supplier;
                let lastIndexOfSupplier = cRslt.map(item => item.supplier).lastIndexOf(supplier); 
                let yAxisIndex = lastIndexOfSupplier !== -1 ? supplierKeysfourth1.indexOf(supplier) : null;
                let value = lastIndexOfSupplier !== -1 ? cRslt[lastIndexOfSupplier].value : null;
                let color = value === "E" ? 'black' : cRslt[i].label ? 'white' : 'rgb(0, 90, 112)';
                pRsltfourth1.push({ x: index + 1, y: yAxisIndex, value, color, dataLabels: cRslt[i].label, borderColor: '#005A70' });
              }
            } else {
              pRsltfourth1.push({ x: index + 1, y: 0, value: Number(pArrItem), color: null })
            }
          })
          if (pRsltfourth1.filter((obj) => obj.y == 7).length == 0) {
            pRsltfourth1.push({ "x": xAxisMinMax.fourth.max, "y": 7, "value": 0, "color": null });
          }
          if (pRsltfourth1.filter((obj) => obj.y == 0).length == 0) {
            pRsltfourth1.push({ "x": 0, "y": 0, "value": 0, "color": null });
          }

          //fourthQuarterReq2PerWeek
          fourthQuarterSKU2Supplires = simObj?.graphdata;
          fourthQuarterSKU2Supplires = fourthQuarterSKU2Supplires?.filter(obj => obj?.qt === 4);
          fourthQuarterSKU2Supplires = (fourthQuarterSKU2Supplires != undefined ? fourthQuarterSKU2Supplires : []).map((data) => {
            return {
              x: data.wn,
              y: Math.floor(data.c2pw),
              requiredComponent2PerWeek: data.c2pw,
              supplierOrderDetailsComp2: data.so.Component2,
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            fourth: fourthQuarterSKU2Supplires
          }));
          setXAxisMinMax(prevData => ({
            ...prevData,
            fourth: { min: 1, max: xAxisMinMax.fourth.max }
          }));

          let fourthQuarterSKU2 = fourthQuarterSKU2Supplires.map((item) => item.supplierOrderDetailsComp2)
          //let valuesToCompare = ["receivedOrdersUnits", "remainingUnits", "weeklySupplyPerUnit"];  
          let supplierKeysfourth2 = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp1Available == 1
          }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
            return simObj?.supplierDetails[supplier].supplierComp2Available == 1
          })]

          let pRsltfourth2 = [];
          fourthQuarterSKU2.forEach((pArrItem, index) => {
            if (Array.isArray(pArrItem)) {
              let cRslt = [];
              let dataLabelColor = '#D46719';
              let dataLabelStroke = '#D46719';
              let dataLabelFillColor = 'white';
              pArrItem.forEach((cArrItem) => {
                if (cArrItem.pendingUnits !== undefined) {
                  cArrItem.dataLabels = { color: dataLabelColor, borderColor: dataLabelStroke, fillColor: dataLabelFillColor };
                  // pendingUnits
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": Number(cArrItem.pendingUnits), "label": cArrItem.dataLabels });
                } else {
                  cRslt.push({ "supplier": cArrItem.supplierId, "value": (cArrItem.scmIssuesTypes && cArrItem.scmIssuesTypes.indexOf("_") !== -1) ? "E" : Number(cArrItem.receivedOrdersUnits) });
                }
              })
              for (var i = 0; i < cRslt.length; i++) {
                let supplier = cRslt[i].supplier;
                let lastIndexOfSupplier = cRslt.map(item => item.supplier).lastIndexOf(supplier); 
                let yAxisIndex = lastIndexOfSupplier !== -1 ? supplierKeysfourth2.indexOf(supplier) : null;
                let value = lastIndexOfSupplier !== -1 ? cRslt[lastIndexOfSupplier].value : null;
                let color = value === "E" ? 'black' : cRslt[i].label ? 'white' : 'rgb(212, 103, 25)';

                pRsltfourth2.push({ x: index + 1, y: yAxisIndex, value, color, dataLabels: cRslt[i].label, borderColor: '#D46719' });
              }
            } else {
              pRsltfourth2.push({ x: index + 1, y: 0, value: Number(pArrItem), color: null })
            }
          })

          if (pRsltfourth2.filter((obj) => obj.y == 7).length == 0) {
            pRsltfourth2.push({ "x": xAxisMinMax.fourth.max, "y": 7, "value": 0, "color": null });
          }
          if (pRsltfourth2.filter((obj) => obj.y == 0).length == 0) {
            pRsltfourth2.push({ "x": 0, "y": 0, "value": 0, "color": null });
          }
          if (chart !== undefined && chart?.series !== undefined && chart?.series[0] !== undefined) {
            chart?.series[0]?.setData([...pRsltfourth1.filter((obj) => obj.y != null), ...pRsltfourth2.filter((obj) => obj.y != null)]);
          }

          break;

        default:
          break;
      }
      // setDataLabel((simObj?.graphdata != undefined) ? simObj?.graphdata : []);
    }
  }

  //first Required weekly delivery
  let firstQuarterReq1PerWeek = [80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80, 80];
  let secondQuarterReq1PerWeek = [11, 80, 35, 19, 65, 69, 14, 33, 77, 66, 85, 60, 30];
  let thirdQuarterReq1PerWeek = [83, 68, 47, 98, 55, 88, 67, 95, 93, 85, 16, 34, 50, 40];
  let fourthQuarterReq1PerWeek = [78, 93, 91, 53, 40, 57, 79, 50, 6, 49, 62, 10, 50];
  //second Required weekly delivery
  let firstQuarterReq2PerWeek = [18, 20, 25, 30, 45, 55, 60, 70, 80, 90, 100, 50];
  let secondQuarterReq2PerWeek = [18, 20, 25, 30, 45, 55, 60, 70, 80, 90, 100, 80, 40];
  let thirdQuarterReq2PerWeek = [18, 20, 25, 30, 45, 55, 60, 70, 80, 90, 100, 80, 20, 30];
  let fourthQuarterReq2PerWeek = [18, 20, 25, 30, 45, 55, 60, 70, 80, 90, 100, 80, 70];


  var isMacbookSafari = function isMacbook() {
    const userAgent = navigator.userAgent.toLowerCase();
    return userAgent.includes("macintosh") && userAgent.includes("safari") && !userAgent.includes("chrome");
  }
  const xAxis = {
    "first": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      categories: [],
      lineColor: '#C6C6C3',
      gridLineColor: '#D1D1D1', // Set the grid line color for the x-axis
      gridLineWidth: 1, // Set the grid line width for the x-axis
      showEmpty: true, // Show grid lines and labels for empty categories
      title: {
        text: "Week",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      }
    },
    "second": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      categories: [],
      lineColor: '#C6C6C3',
      gridLineColor: '#D1D1D1', // Set the grid line color for the x-axis
      gridLineWidth: 1, // Set the grid line width for the x-axis
      showEmpty: true, // Show grid lines and labels for empty categories
      title: {
        text: "Week",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      }
    },
    "third": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      categories: [],
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      startOnTick: true,
      gridZIndex: 4,
      tickInterval: 1,
      tickLength: 0,
      title: {
        text: "Week",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      accessibility: {
        point: {

        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      }
    },
    "fourth": {
      min: xAxisMinMax[type].min,
      max: xAxisMinMax[type].max,
      categories: [],
      color: 'rgb(242,242,242)',
      lineColor: '#C6C6C3',
      gridLineWidth: 1,
      gridZIndex: 4,
      tickInterval: 1,
      startOnTick: true,
      tickLength: 0,
      accessibility: {
        point: {

        }
      },
      title: {
        text: "Week",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      labels: {
        rotation: 0,
        step: 1,
        style: {
          fontSize: '0.8em'
        }
      }

    },
  }

  const UnitsBySuppliersCategories = [...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
    return simObj?.supplierDetails[supplier].supplierComp1Available == 1
  }), ...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
    return simObj?.supplierDetails[supplier].supplierComp2Available == 1
  })].map(supplierKey => simObj?.supplierDetails[supplierKey].supplierName)

  const SKU1dashedLine = ([...Object.keys(simObj?.supplierDetails != null && simObj?.supplierDetails).filter((supplier) => {
    return simObj?.supplierDetails[supplier].supplierComp1Available == 1
  })].length - 1);

  const yAxis = {
    "first": {
      categories: UnitsBySuppliersCategories,
      title: null,
      reversed: true,
      gridLineColor: '#D1D1D1', // Set the grid line color for the x-axis
      gridLineWidth: 1, // Set the grid line width for the x-axis
      showEmpty: true, // Show grid lines and labels for empty categories
      plotLines: [{
        color: 'rgb(112,112,112,1.5)',
        width: 1,
        value: SKU1dashedLine + (0.5),
        dashStyle: 'Dash',
        zIndex: 5, // To ensure the line is above the heatmap

      }]
    },
    "second": {
      categories: UnitsBySuppliersCategories,
      title: null,
      reversed: true,
      gridLineColor: '#D1D1D1', // Set the grid line color for the x-axis
      gridLineWidth: 1, // Set the grid line width for the x-axis
      showEmpty: true, // Show grid lines and labels for empty categories
      plotLines: [{
        color: 'rgb(112,112,112,1.5)',
        width: 1,
        value: SKU1dashedLine + (0.5),
        dashStyle: 'Dash',
        zIndex: 5, // To ensure the line is above the heatmap

      }]
    },
    "third": {
      categories: UnitsBySuppliersCategories,
      title: null,
      reversed: true,
      gridLineColor: '#D1D1D1', // Set the grid line color for the x-axis
      gridLineWidth: 1, // Set the grid line width for the x-axis
      showEmpty: true, // Show grid lines and labels for empty categories
      plotLines: [{
        color: 'rgb(112,112,112,1.5)',
        width: 1,
        value: SKU1dashedLine + (0.5),
        dashStyle: 'Dash',
        zIndex: 5, // To ensure the line is above the heatmap

      }]

    },
    "fourth": {
      categories: UnitsBySuppliersCategories,
      title: null,
      reversed: true,
      gridLineColor: '#D1D1D1', // Set the grid line color for the x-axis
      gridLineWidth: 1, // Set the grid line width for the x-axis
      showEmpty: true, // Show grid lines and labels for empty categories
      plotLines: [{
        color: 'rgb(51, 51, 51,1.5)',
        width: 1,
        value: SKU1dashedLine + (0.5),
        dashStyle: 'Dash',
        zIndex: 5, // To ensure the line is above the heatmap

      }]

    },
  }

  function applyAccessibility(chart) {
    if (chart && chart.renderTo) {
      const svg = chart.renderTo.querySelector("svg.highcharts-root");
      if (svg) {
        setTimeout(() => {
        svg.setAttribute('role', 'img');

        svg.setAttribute('aria-label', 'Units by supplier graph.');

        const oldDesc = svg.querySelector("desc");
        if (oldDesc) oldDesc.remove();

        const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
        desc.textContent = "This chart shows the number of units delivered by each supplier per week. It includes SKU1 and SKU2 deliveries, pending units, and weeks with no delivery. Each bar represents the delivery status for a given supplier during the selected quarter.";
        svg.insertBefore(desc, svg.firstChild);
        },0);
      }
    }
  }
  graphSettings = {
    plotOptions: {
      events: {
        legendItemClick: function () {
          return false; // Prevent default legend item click behavior
        }
      },
      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    chart: {
      type: "heatmap",
      responsive: false,
      //marginRight: 10,
      //marginLeft:53,
      height: isMacbookSafari() ? 200 : 250,
      plotBorderWidth: 1,
      events: {
          render: function () {
              applyAccessibility(this);
          },
          redraw: function () {
              applyAccessibility(this);
          }
      }
    },
    title: null,
    legend: {
      enabled: false,
      align: 'left',
      verticalAlign: 'top',
      // floating: true,
      visible: true,
      itemStyle: {
        fontWeight: 'bold',
        fontSize: '12px'
      }
    },
    xAxis: xAxis[type],
    yAxis: yAxis[type],
    colorAxis: {
      min: 0,
      minColor: 'rgba(255, 255, 255)',
      maxColor: 'rgba(255, 255, 255)'
    },
    accessibility: {
      enabled: true,
      description: '',
      pointDescriptionFormatter: function (point) {
        const yCategory = point.series.yAxis.categories[point.y];
        // Customize the aria-label for each point
          return `${point.x != 0 ? `Week: ${point.x}; ${(point.color === "rgb(0, 90, 112)") ? `SKU1 units delivered` : (point.color === "rgb(212, 103, 25)") ? `SKU2 units delivered` : (point.color === "black") ? `No delivery this week` : (point.borderColor === "#005A70") ? `SKU1 units pending` : (point.borderColor === "#D46719" ) ? `SKU2 units pending` : (point.color === "rgba(255, 255, 255)") && `` } ${point.value === 'E' ? `` : point.value} sales by ${yCategory} Supplier;` : ''}`;
      },
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      },
      screenReaderSection: {
        beforeChartFormat: '' // disables their auto "Interactive chart" label
      }
    },
    credits: {
      enabled: false
    },
    series: [{
      data: [],
      // data: [
      //   { x: 1, y: 0, value: 1100, color: 'rgb(0, 90, 112)' },

      //   { x: 0, y: 7, value: 120, color: '#D46719' },
      //   { x: 1, y: 0, value: 1100, color: 'rgb(0, 90, 112)' },

      //   { x: 1, y: 7, value: 120, color: '#D46719' },
      //   { x: 2, y: 0, value: 100, color: 'rgb(0, 90, 112)' },

      //   { x: 2, y: 7, value: 120, color: '#D46719' },

      //   { x: 3, y: 1, value: 100, color: 'rgb(0, 90, 112)' },

      //   { x: 3, y: 7, value: 120, color: '#D46719' },
      //   { x: 11, value: 0 }
      // ],
      dataLabels: {
        enabled: true,
        color: '#FFFFFF',
        style: {
          textOutline: '1px contrast', // Text outline for better visibility
          fontSize: '9px', // Set the font size for data labels
          fontWeight:500
        },
        backgroundColor: function () {
          return this.point.x === 1 && this.point.y === 0 ? 'lightyellow' : 'none';
        },
        formatter: function () {
          return this.point.value.toString().replace(',', ''); // Remove comma from the value
        }
      }
    }],
    tooltip: {
      enabled: false
    }

  }


  useEffect(() => {
    const newChart = Highcharts.chart("Units-Supplier", graphSettings);
    setChart(newChart);
    // if (type === "first" || type === "second" || type === "third" || type === "fourth") {
    //   const g_container = ScmModuleStyle['graph-container'];
    //   let gContainer = document.getElementsByClassName(`${g_container}`)[0];
    //   gContainer.setAttribute("tabindex", '-1');
    //   gContainer.focus();
    // }

  }, [type,quarterMax]);

  useEffect(() => {
    if(simObj?.laststate?.stateyear !== undefined){
      for (let quarter = 1; quarter <= 4; quarter++) {
        const saturdayCount = countSaturdaysInQuarter(quarter);
        setQuarterMax((prevData) => [...prevData, saturdayCount]);
      }
    }
  }, [simObj?.laststate?.stateyear]);

  useEffect(() => {   
    setGraphData();
    if (chart != undefined) {
      setUnitsBySuppliersGraphLabel(`Revenue and Cost of quality graph representing along Y-axis with ${chart?.yAxis != undefined && chart?.yAxis[0].tickInterval}$ per unit scale and Time quarter along X-axis with 1 quarter per unit scale.`);
      document.querySelector("#Units-Supplier").setAttribute('role', `figure`);
      document.querySelector("#Units-Supplier .highcharts-container ").setAttribute('tabindex', '0');
    }
  }, [chart, simObj?.graphdata, simObj?.laststate]);

  useEffect(()=>{
    for(let i=0;i<quarterMax.length;i++){
     setXAxisMinMax((prevData) => {
       return {
         ...prevData,
         [i === 0 ? 'first' : i === 1 ? 'second' : i === 2 ? 'third' : 'fourth']: {
           min: 1,
           max: quarterMax[i],
         },
       };
     });
    }
   },[quarterMax,chart])
   
//  useEffect(()=>{
//     console.log(xAxisMinMax)
//    },[xAxisMinMax])
  return (
    <div className={`${ScmModuleStyle['graph-container']}`}>
      <a href="#" onClick={(e) => e.preventDefault()} aria-label="Legends with a filled color square indicate delivered units for SKU1 and SKU2, no fill color signifies pending units, and a box with the letter 'E' denotes no deliveries for the week." className="sr-only"></a>
      <div id="Units-Supplier" className={`${ScmModuleStyle['revenue-graph']}`} aria-label={revenueGraphLabel} role='figure'>
      </div>
    </div>
  )
}

export default UnitsBySuppliersGraph